import React, {Component, Fragment} from 'react'
import {connect} from 'react-redux'
import autobind from 'autobind-decorator'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {remove} from 'catalog/actions/attachments'

@connect(
    null,
    dispatch => ({
        remove: attachment => dispatch(remove(attachment))
    })
)
export default class DeleteAttachment extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isOpen: false
        }
    }

    @autobind
    toggle() {
        const isOpen = !this.state.isOpen
        this.setState({isOpen})
    }

    @autobind
    confirm() {
        const {
            remove,
            attachment
        } = this.props
        remove(attachment)
        this.toggle()
    }

    render() {
        const {attachment} = this.props
        return (
            <Fragment>

                <Button color="danger" onClick={this.toggle}>
                    <i className='fa fa-trash'> </i>
                </Button>
                <Modal isOpen={this.state.isOpen}>
                    <ModalHeader>
                        Anhang löschen
                    </ModalHeader>
                    <ModalBody>
                        Sind Sie sicher, dass Sie den Anhang <a href={attachment.file}
                                                                style={{'whiteSpace': 'nowrap'}}>{attachment.name}</a> löschen
                        möchten?
                    </ModalBody>
                    <ModalFooter>
                        <Button color='danger' onClick={this.confirm}>Bestätigen</Button>
                        <Button color='default' onClick={this.toggle}>Abbrechen</Button>
                    </ModalFooter>
                </Modal>
            </Fragment>

        )
    }
}
